import { HttpClient } from '@angular/common/http';
import { CartonPackingEnvProvider } from './carton-packing-env.provider';
import {
  TCartonPackingDashboardCountResponse,
  TCartonPackingBuyerListingRequest,
  TCartonPackingBuyerListingResponse,
  TCartonPackingSetPackListingRequest,
  TCartonPackingSetPackListingResponse,
  TCartonPackingAllTransactionsRequest,
  TCartonPackingAllTransactionsResponse,
  TCartonDetailsResponse,
  TCartonCreateRequest,
  TCartonCreateResponse,
  TCartonEditRequest,
  TCartonEditResponse,
  TCartonPackingDashboardCountRequest,
  TSetPackListingRequest,
  TSetPackListingResponse,
} from '@monorepo/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CartonPackingDataProvider {
  constructor(private http: HttpClient, private cartonPackingEnvProvider: CartonPackingEnvProvider) {}

  fetchCartonPackingDashboardCount(request: TCartonPackingDashboardCountRequest) {
    return this.http.post<TCartonPackingDashboardCountResponse>(
      this.cartonPackingEnvProvider.getEnvVar('GET_CARTON_PACKING_DASHBOARD_COUNT'),
      request,
    );
  }

  fetchCartonPackListing(request: TSetPackListingRequest) {
    return this.http.post<TSetPackListingResponse>(
      this.cartonPackingEnvProvider.getEnvVar('GET_SET_PACK_LISTING'),
      request,
    );
  }

  fetchCartonPackingBuyerListing(request: TCartonPackingBuyerListingRequest) {
    return this.http.post<TCartonPackingBuyerListingResponse>(
      this.cartonPackingEnvProvider.getEnvVar('GET_CARTON_PACKING_BUYER_LISTING'),
      request,
    );
  }

  fetchCartonPackingSetPackListing(request: TCartonPackingSetPackListingRequest) {
    return this.http.post<TCartonPackingSetPackListingResponse>(
      this.cartonPackingEnvProvider.getEnvVar('GET_CARTON_PACKING_SET_PACK_LISTING'),
      request,
    );
  }

  fetchCartonPackingAllTransactions(request: TCartonPackingAllTransactionsRequest) {
    return this.http.post<TCartonPackingAllTransactionsResponse>(
      this.cartonPackingEnvProvider.getEnvVar('GET_CARTON_PACKING_ALL_TRANSACTIONS'),
      request,
    );
  }
  fetchCartonDetails(cartonId: string) {
    const baseUrl = this.cartonPackingEnvProvider.getEnvVar('GET_CARTON_DETAILS');
    const url = `${baseUrl}/${cartonId}`;
    return this.http.get<TCartonDetailsResponse>(url);
  }

  createCarton(request: TCartonCreateRequest) {
    return this.http.post<TCartonCreateResponse>(this.cartonPackingEnvProvider.getEnvVar('CREATE_CARTON'), request);
  }

  editCarton(request: TCartonEditRequest) {
    return this.http.post<TCartonEditResponse>(this.cartonPackingEnvProvider.getEnvVar('EDIT_CARTON'), request);
  }
}
